//
//
//
//
//
//
//
//
//
//
//
//


export default {
	name: "LocationBox",
	props: {
		location: Object
	},
	computed: {
		addressDisplayString() {
			return this.location.address1 + (!!this.location.address2 ? ", " + this.location.address2 : "");
		},
		addressDirectionsHref() {
			let string = this.location.address1 + " " + (!!this.location.address2 ? this.location.address2 + " " : "") + this.location.city + " " + this.location.state + " " + this.location.zipCode;
			return encodeURI(string);
		}
	}
}
